import { render, staticRenderFns } from "./Dockers.vue?vue&type=template&id=c458315c"
import script from "./Dockers.vue?vue&type=script&lang=js"
export * from "./Dockers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports